import React from 'react'
import { Skeleton } from 'antd'

import styles from './ListViewSkeleton.module.css'

const SECTION_COUNT = 3
const ROWS_PER_SECTION = [5, 4, 4]

const ListViewSkeleton = () => (
    <div className={styles.root} aria-busy="true" aria-label="Loading tasks">
        <div className={styles.tableHeader}>
            <Skeleton.Input active size="small" className={styles.headerCell} />
            <Skeleton.Input active size="small" className={styles.headerCell} />
            <Skeleton.Input active size="small" className={styles.headerCell} />
            <Skeleton.Input active size="small" className={styles.headerCell} />
        </div>
        {Array.from({ length: SECTION_COUNT }).map((_, sectionIndex) => (
            <div key={sectionIndex} className={styles.section}>
                <div className={styles.sectionHeader}>
                    <Skeleton.Avatar active size={16} shape="square" />
                    <Skeleton.Input
                        active
                        size="small"
                        className={styles.sectionTitle}
                    />
                </div>
                {Array.from({
                    length: ROWS_PER_SECTION[sectionIndex] || 4,
                }).map((__, rowIndex) => (
                    <div key={rowIndex} className={styles.row}>
                        <Skeleton.Input
                            active
                            size="small"
                            className={styles.rowTitle}
                        />
                        <Skeleton.Avatar active size={24} shape="circle" />
                        <Skeleton.Input
                            active
                            size="small"
                            className={styles.rowMeta}
                        />
                        <Skeleton.Input
                            active
                            size="small"
                            className={styles.rowMeta}
                        />
                    </div>
                ))}
            </div>
        ))}
    </div>
)

export default ListViewSkeleton
